import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { connect } from "react-redux";
import { downloadPeriodicReport } from "../../../store/recruitment/actions";

const PeriodicReports = (props) => {
  const { downloadPeriodicReport } = props;
  const [reportType, setReportType] = useState("summary");
  const [appealLevel, setAppealLevel] = useState(2);
  const [position, setPosition] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
   const [entitySectorId, setEntitySectorId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const handleGetData = () => {
    downloadPeriodicReport(
      {
        reportType,
        position,
        dateFrom,
        dateTo,
        searchTerm,
        appealLevel,
        entitySectorId
      },
      setIsDownloading
    );
  };

  return (
    <Box
      sx={{
        height: "90vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f0f2f5",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box
          sx={{
            maxWidth: 500,
            padding: 4,
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          {/* Title */}
          <Typography variant="h5" gutterBottom align="center" fontWeight={600}>
            Periodic Reports
          </Typography>

          {/* Radio Buttons */}
          <FormControl component="fieldset" fullWidth sx={{ mt: 0 }}>
            <FormLabel component="legend">Report Type</FormLabel>
            <RadioGroup
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
              row
            >
              <FormControlLabel
                value="summary"
                control={<Radio />}
                label="Summary"
              />
              <FormControlLabel
                value="appeals"
                control={<Radio />}
                label="Appeals"
              />
              <FormControlLabel
                value="advertisements"
                control={<Radio />}
                label="Advertised Positions"
              />
                <FormControlLabel
                value="fromWaitingList"
                control={<Radio />}
                label="From Waiting-list"
              />
              <FormControlLabel
                value="hiredFromWaitingList"
                control={<Radio />}
                label="Hired from Waiting-list"
              />
            </RadioGroup>
          </FormControl>

          {/* Position Select */}
          {/* <FormControl fullWidth margin="normal">
            <InputLabel id="position-label">Position</InputLabel>
            <Select
              labelId="position-label"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              label="Position"
            >
              <MenuItem value="officer">Officer</MenuItem>
              <MenuItem value="manager">Manager</MenuItem>
              <MenuItem value="analyst">Analyst</MenuItem>
            </Select>
          </FormControl> */}
          {reportType==='appeals' &&  <FormControl fullWidth margin="normal">
            <InputLabel id="appeal-level">Level</InputLabel>
            <Select
              labelId="appeal-level"
              value={appealLevel}
              onChange={(e) => setAppealLevel(+e.target.value)}
              label="Level"
            >
              <MenuItem value="1">First Level</MenuItem>
              <MenuItem value="2">Second Level</MenuItem>
            </Select>
          </FormControl>}
         

          {/* Date Pickers */}
          <Stack direction="row" spacing={2} mt={2}>
            <DesktopDatePicker
              label="Date From"
              inputFormat="dd/MM/yyyy"
              value={dateFrom}
              onChange={(newValue) => setDateFrom(newValue)}
              slotProps={{ textField: { fullWidth: true } }}
              renderInput={(params) => (
                <TextField
                  onKeyDown={(e) => e.preventDefault()}
                  required={true}
                  fullWidth
                  size="small"
                  {...params}
                />
              )}
            />

            <DesktopDatePicker
              label="Date To"
              inputFormat="dd/MM/yyyy"
              value={dateTo}
              onChange={(newValue) => setDateTo(newValue)}
              slotProps={{ textField: { fullWidth: true } }}
              renderInput={(params) => (
                <TextField
                  onKeyDown={(e) => e.preventDefault()}
                  required={true}
                  fullWidth
                  size="small"
                  {...params}
                />
              )}
            />
          </Stack>

          {/* Search Input */}
          {/* <TextField
            fullWidth
            label="Search"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ mt: 3 }}
          /> */}

          {/* Button */}
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleGetData}
            sx={{ mt: 2 }}
            disabled={isDownloading}
          >
            {isDownloading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  style={{ fontSize: "28px" }}
                ></span>
                <span className="sr-only">Loading...</span>
              </>
            ) : (
              <>
                <span
                  className="material-icons px-2"
                  style={{ fontSize: "28px" }}
                >
                  cloud_download
                </span>{" "}
                Get Data
              </>
            )}
          </Button>
        </Box>
      </LocalizationProvider>
    </Box>
  );
};

const mapStateToProps = ({ user, loading }) => {
  return { user, loading };
};
export default connect(mapStateToProps, { downloadPeriodicReport })(
  PeriodicReports
);
